import axios from "axios";

const sendBitacora = async (formData, token) => {
  try {
    const response = await axios.post(`${API_URL}/api/logbook`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error("Error al enviar bitácora:", error);
    let errorMessage = "Error al enviar el formulario";

    if (error.response) {
      switch (error.response.status) {
        case 401:
          errorMessage = "No autorizado - Token inválido o expirado";
          break;
        case 413:
          errorMessage = "Los archivos son demasiado grandes";
          break;
        default:
          errorMessage = error.response.data?.message || errorMessage;
      }
    } else if (error.request) {
      errorMessage = "No se recibió respuesta del servidor";
    }

    return { success: false, error: errorMessage };
  }
};

export default { sendBitacora };

export const getAllCommerce = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/commerce/get-all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener usuarios";
  }
};
